import { Actions, createNamespace } from "../../../../../flux/Actions";
import { SensorsDataResult } from "../../../../../rest/Geotab";
import { Coordinate } from "./interfaces";

const ns = createNamespace('SENSORS_DATA');
export const names = {
    SET_GRAPH_VIEW: ns('SET_GRAPH_VIEW'),
    SET_TABLE_VIEW: ns('SET_TABLE_VIEW'),
    TOGGLE_MAP: ns('TOGGLE_MAP'),
    SET_COORDINATE: ns('SET_COORDINATE'),
    SET_SENSORS_DATA: ns('SET_SENSORS_DATA'),
};

export class SensorsDataActions extends Actions
{
    setGraphView = () => this.dispatch(names.SET_GRAPH_VIEW);
    setTableView = () => this.dispatch(names.SET_TABLE_VIEW);      
    toggleMap = () => this.dispatch(names.TOGGLE_MAP);
    setCoordinate = (lon: number, lat: number) => this.dispatch(names.SET_COORDINATE, { lon, lat } as Coordinate);
    setSensorsData = (data: SensorsDataResult) => this.dispatch(names.SET_SENSORS_DATA, data);
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/SensorsData/flux/Actions.ts